module.exports = __webpack_public_path__ + "assets/b13b266182159b23c898eb49e709b62a.png";